export default __webpack_public_path__ + "d7b232231fc04ff22dfbf15d51a17879.svg";